<template>
  <div>
    <button @click="click">上传文件</button>
    <div v-for="(file, index) in fileList" :key="index">
      文件名: {{ file.name }}
	  <el-progress :percentage="file.progress" :show-text="false" />
      <span v-if="file.progress !== null">进度: {{ file.progress }}%</span>
    </div>
    <input class="layout-file" style="height: 0px" type="file" @change="handleFileChange" ref="inputer" multiple
      :accept="accept" />
  </div>
</template>

<script setup>
import uploadByPieces from '@/assets/js/uploadNew';
import { ref } from 'vue';

const fileList = ref([]);
const accept = ref('.png,.jpg,.gif,.svg,.jpeg,.mp4');
const inputer = ref(null);

function click() {
  inputer.value.click();
}

function handleFileChange() {
	console.log('执行没')
  const files = Array.from(inputer.value.files);
  
  files.forEach((file) => {
    const fileName = file.name;
    const fileData = {
      name: fileName,
      progress: 0
    };
    
    fileList.value.push(fileData);

    uploadByPieces(file, 1, 3,
      (res) => {
        const index = fileList.value.findIndex((f) => f.name === fileName);
        if (index !== -1) {
			
          fileList.value[index].progress = 100;
          // 处理上传成功逻辑
          const params = {
            title: fileName.substring(0, fileName.lastIndexOf('.') + 1),
            filePath: res.data.url,
            materialType: 'VIDEO'
          };
          console.info(params);
        }
      },
      (p) => {
        const index = fileList.value.findIndex((f) => f.name === fileName);
        if (index !== -1) {
          fileList.value[index].progress = p ;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  });
}
</script>